module.exports = __webpack_public_path__ + "img/WP2023-Presenters.a993417f.jpg";